var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPolls(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 800,
    height: 654.8,
    viewBox: "0 0 800 654.8",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    role: "img",
    artist: "Katerina Limpitsouni",
    source: "https://undraw.co/",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-443.84 -102.182)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(548.211 159.5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M121.992,531.053l-18.611,0L98.9,470.116l23.089-4.889Z",
    transform: "translate(467.802 55.274)",
    fill: "#9f616a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.979,526.328h0c-.579.976-.885,4.126-.885,5.261h0a6.317,6.317,0,0,0,6.317,6.317h57.635a4.309,4.309,0,0,0,4.309-4.309v-2.4s2.851-7.212-3.019-16.1c0,0-7.3,6.96-18.2-3.941l-3.215-5.824L110.653,522.35l-12.9,1.588c-2.822.347-5.324-.054-6.775,2.391Z",
    transform: "translate(435.053 59.576)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.109,529.846l-18.611,0-3.344-59.48L126.9,452.255Z",
    transform: "translate(369.278 56.481)",
    fill: "#9f616a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.979,526.328h0c-.579.976-.885,4.126-.885,5.261h0a6.317,6.317,0,0,0,6.317,6.317h57.635a4.309,4.309,0,0,0,4.309-4.309v-2.4s2.851-7.212-3.019-16.1c0,0-7.3,6.96-18.2-3.941l-3.215-5.824L110.653,522.35l-12.9,1.588c-2.822.347-5.324-.054-6.775,2.391Z",
    transform: "translate(336.645 59.576)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0H28.225l5.332,31.744H0Z",
    transform: "translate(512.51 127.537)",
    fill: "#9f616a"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 342.833,
    height: 82.534,
    transform: "translate(92.895 0.029)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.214,4.214V79.005H338.143V4.214H4.214M0,0H342.356V83.219H0Z",
    transform: "translate(93.371 0)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M881.354,667.732a8.154,8.154,0,0,1-6.406,4.339c-.689.068-.493,1.125.192,1.057a9.138,9.138,0,0,0,7.1-4.785.555.555,0,0,0-.136-.748A.54.54,0,0,0,881.354,667.732Z",
    transform: "translate(-235.75 -162.495)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M643.708,177.5a10.479,10.479,0,0,0,3.158,15.755l-6.128,36.731,17.687-7.85,3.107-33.676A10.536,10.536,0,0,0,643.708,177.5Z",
    transform: "translate(-214 -116.536)",
    fill: "#9e616a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M704.008,451.188,698.6,458.3s-.489,3.32-8.689,30.37l-3.464,213.611,26.708,4.157,35.837-177.127,37.746,165.942,23.587,1.392-1.109-188.611s2.979-38.8-7.581-46.009S704.008,451.188,704.008,451.188Z",
    transform: "translate(-218.253 -142.37)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 28.552,
    cy: 28.552,
    r: 28.552,
    transform: "translate(493.692 83.219)",
    fill: "#9e616a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M771.4,231.077l-.472-.943c-.729-1.458-6.766-13.582-7.524-16.7l-7.6.894-19.786,0,2.749-4.124-7.269.948a16.682,16.682,0,0,0-7.407,2.792,11.349,11.349,0,0,0-3.36,3.464c-2.6,4.446-6.563,11.719-6.6,11.792l-.379.7-3.3-5.545c-.043-.215-4.128-21.523,9.544-28.75.705-1.432,6.714-12.7,20.915-11.937a9,9,0,0,1,6.121-3.043c3.243-.169,6.61,1.535,9.991,5.085,4.491,4.716,10.642,11.173,14.362,18.343l1.026,1.464a11.539,11.539,0,0,1,2.053,7.164,23.919,23.919,0,0,1-.815,12.2Z",
    transform: "translate(-220.43 -114.837)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M763.5,268.729l15.8,8.732,31.034,8.69-9.263,81.215,1.685,80s-52.532,35.987-102.9-6.041V340.628l2.98-54.477s12.054-3.424,18.124,2.483l11.511-14.953Z",
    transform: "translate(-219.5 -125.395)",
    fill: "#273679"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M497.5,142.089l-6.961-7.482-38.359-4.345,3.6-58.916-20.914-14.92L419.5,139.368l70.977,49.715Z",
    transform: "translate(-7.209 26.15)",
    fill: "#273679"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M796.523,489.938A10.479,10.479,0,0,1,806.7,477.5l11.81-35.316,11.942,15.227-13.046,31.2a10.536,10.536,0,0,1-20.883,1.322Z",
    transform: "translate(-228.477 -141.533)",
    fill: "#9e616a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M808.158,297.234l11.659-9.3s11.922,6.576,15.549,18.366,9.977,78.906,9.977,78.906l-17.232,86.162L808.84,458.006l9.295-68.262-16.325-49.883Z",
    transform: "translate(-228.986 -127.182)",
    fill: "#273679"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 24.789,
    cy: 24.789,
    rx: 24.789,
    ry: 24.789,
    transform: "translate(140.381 16.706)",
    fill: "#273679"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 165.837,
    height: 5.389,
    transform: "translate(224.448 31.795)",
    fill: "#273679"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 165.837,
    height: 5.389,
    transform: "translate(224.448 45.806)",
    fill: "#273679"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.309,265.054,473.85,284.641V355.15l-268.541-4.987Z",
    transform: "translate(-205.309 -140.043)",
    fill: "#d6d6e3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.95,351.354l260.081,5.416V294.222L213.95,275.02Z",
    transform: "translate(-209.721 -145.405)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.474,286.622a20.213,20.213,0,0,1,8.375,2.425,23.315,23.315,0,0,1,6.77,5.583,26.367,26.367,0,0,1,4.53,7.9,27.635,27.635,0,0,1,1.655,9.441,26.366,26.366,0,0,1-1.655,9.29,23.416,23.416,0,0,1-4.53,7.492,20.446,20.446,0,0,1-6.77,4.964,19,19,0,0,1-8.375,1.658A20.055,20.055,0,0,1,262,333.2a23.106,23.106,0,0,1-6.988-5.493,26.26,26.26,0,0,1-4.747-8.02A27.624,27.624,0,0,1,248.521,310a26.326,26.326,0,0,1,1.748-9.537,23.274,23.274,0,0,1,4.748-7.582,20.3,20.3,0,0,1,6.988-4.853A18.988,18.988,0,0,1,270.474,286.622Z",
    transform: "translate(-206.219 -140.496)",
    fill: "#d6d6e3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.037,304.444l123.729,6.448v4.686l-123.729-6.012Z",
    transform: "translate(-207.766 -140.872)",
    fill: "#d6d6e3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.037,318.051l123.729,5.311v4.686l-123.729-4.875Z",
    transform: "translate(-207.766 -141.158)",
    fill: "#d6d6e3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.309,411.259l268.541-4.986v70.509L205.309,496.37Z",
    transform: "translate(-205.309 -167.523)",
    fill: "#d6d6e3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.95,499.386l260.081-19.994V416.315l-260.081,5.22Z",
    transform: "translate(-209.72 -173.96)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.539,451.19a27.588,27.588,0,0,1,2.138-9.613,25.941,25.941,0,0,1,5.058-7.774,22.713,22.713,0,0,1,7.186-5.135,19.816,19.816,0,0,1,8.528-1.743,19.033,19.033,0,0,1,8.28,2.085,20.737,20.737,0,0,1,6.549,5.308,23.808,23.808,0,0,1,4.218,7.725,26.636,26.636,0,0,1,1.281,9.379,27.6,27.6,0,0,1-2.024,9.367,26.065,26.065,0,0,1-4.836,7.687,22.925,22.925,0,0,1-6.978,5.247,19.959,19.959,0,0,1-8.454,2,19.006,19.006,0,0,1-8.394-1.842,20.584,20.584,0,0,1-6.77-5.217,23.675,23.675,0,0,1-4.427-7.836A26.6,26.6,0,0,1,248.539,451.19Z",
    transform: "translate(-206.218 -167.957)",
    fill: "#d6d6e3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.037,439.972,445.765,435.1v4.686l-123.729,5.311Z",
    transform: "translate(-207.766 -168.129)",
    fill: "#d6d6e3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.037,453.553l123.729-6.01v4.686l-123.729,6.448Z",
    transform: "translate(-207.766 -168.391)",
    fill: "#d6d6e3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M958.151,754.5H612.6a.907.907,0,1,1,0-1.814H958.151a.907.907,0,1,1,0,1.814Z",
    transform: "translate(-263.429 -157.02)",
    fill: "#d6d6e3"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M27.691,83.028h-2.6A8.8,8.8,0,0,1,16.3,74.237V72.053c0-5.411,1.025-9.941,3.047-13.465a70.828,70.828,0,0,1,8.532-11.464,50.524,50.524,0,0,0,5.8-6.993,11.762,11.762,0,0,0,1.832-6.505c0-5.427-3.536-8.066-10.81-8.066a43.9,43.9,0,0,0-11.915,1.788A10.031,10.031,0,0,1,0,17.7V13.281A9.839,9.839,0,0,1,5.8,4.263,53.119,53.119,0,0,1,27.445.006a53.286,53.286,0,0,1,20.89,3.886A33.716,33.716,0,0,1,62.628,14.725a26.09,26.09,0,0,1,5.127,15.813A25.718,25.718,0,0,1,62.8,46.353,90.407,90.407,0,0,1,48.936,60.476a98.772,98.772,0,0,0-8.887,8.372,15.455,15.455,0,0,0-3.695,6.879,8.768,8.768,0,0,1-8.664,7.3Z",
    transform: "translate(443.84 118.574) rotate(-14)",
    fill: "#273679"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.637,32.588h-.343A16.294,16.294,0,1,1,16.294,0h.343a16.294,16.294,0,0,1,0,32.588Z",
    transform: "translate(475.366 205.306) rotate(-14)",
    fill: "#273679"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPolls);
export default __webpack_public_path__ + "static/media/polls.2f268202f0b405cf627290b81a02b24e.svg";
export { ForwardRef as ReactComponent };